<template>
  <section
    id="skills-section"
    class="padding-x py-[1%] text-flax-smoke-200 relative z-10 overflow-y-clip bg-[#0B0B0A] shadow-2xl will-change-auto sm:mt-0"
  >
    <div class="md:column-gap grid grid-cols-12">
      <div class="hide-on-mobile overflow-hidden md:col-span-4">
        <svg
          id="down-arrow-skills"
          stroke="currentColor"
          fill="none"
          stroke-width="1.25"
          viewBox="6 6 12 12"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="hide-on-mobile m-0 size-20 -translate-x-full p-0"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line x1="7" y1="7" x2="17" y2="17"></line>
          <polyline points="17 7 17 17 7 17"></polyline>
        </svg>
      </div>

      <h3
        id="my-skills"
        v-html="mySkills"
        class="heading-1-alt lg:heading-1 section-heading col-span-full leading-none font-extrabold uppercase md:col-span-8 md:col-start-6"
      ></h3>
    </div>

    <div class="py-[1%] mt-3 flex w-full justify-center">
      <div class="w-full mt-5 mx-auto">
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 md:gap-x-8">
          
          <!-- Web Development -->
          <div class="flex flex-col">
            <p class="heading-5 font-bold uppercase mb-4 text-flax-smoke-100">
              ({{ technicalSkills[0].name }})
            </p>
            <p v-for="(skill, sIndex) in technicalSkills[0].items" :key="'skill-'+sIndex" 
               class="skill-card heading-6 font-fancy w-full text-balance text-flax-smoke-300/85">
              {{ skill.name }}
            </p>
          </div>

          <!-- Core Areas -->
          <div class="flex flex-col">
            <p class="heading-5 font-bold uppercase mb-4 text-flax-smoke-100">
              ({{ technicalSkills[2].name }})
            </p>
            <p v-for="(skill, sIndex) in technicalSkills[2].items" :key="'skill-'+sIndex" 
               class="skill-card heading-6 font-fancy w-full text-balance text-flax-smoke-300/85">
              {{ skill.name }}
            </p>
          </div>

          <!-- Programming Languages -->
          <div class="flex flex-col">
            <p class="heading-5 font-bold uppercase mb-4 text-flax-smoke-100">
              ({{ technicalSkills[1].name }})
            </p>
            <p v-for="(skill, sIndex) in technicalSkills[1].items" :key="'skill-'+sIndex" 
               class="skill-card heading-6 font-fancy w-full text-balance text-flax-smoke-300/85">
              {{ skill.name }}
            </p>
          </div>

          <!-- Soft Skills -->
          <div class="flex flex-col">
            <p class="heading-5 font-bold uppercase mb-4 text-flax-smoke-100">
              (Soft Skills)
            </p>
            <p v-for="skill in softSkills" :key="skill" class="skill-card heading-6 font-fancy w-full text-balance text-flax-smoke-300/85">
              {{ skill }}
            </p>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText, animateAboutMeSectionLeave, xToZero } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';
  import gsap from 'gsap';

  const mySkills = ref('Skills /');

  const technicalSkills = [
    {
      name: 'Web Development',
      items: [
        { name: 'HTML5' },
        { name: 'CSS3' },
        { name: 'JavaScript' },
        { name: 'Tailwind CSS' },
        { name: 'PHP' },
        { name: 'GSAP' }
      ]
    },
    {
      name: 'Programming Languages',
      items: [
        { name: 'C++' },
        { name: 'Dart' },
        { name: 'Python' }
      ]
    },
    {
      name: 'Core Areas',
      items: [
        { name: 'Database Management' },
        { name: 'Data Science' },
        { name: 'Machine Learning' }
      ]
    }
  ];

  const softSkills = ['Communication', 'Time Management', 'Leadership Qualities', 'Presentation Skills'];

  onBeforeMount(() => {
    mySkills.value = textSplitterIntoChar('Skills\u00A0/', true, true);
  });

  onMounted(() => {
    animateSplitText(
      '#my-skills .letters',
      '#my-skills',
      1,
      0.01,
      0,
      () => {
        xToZero('#down-arrow-skills');
      },
    );

    gsap.fromTo(
      '.skill-card',
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: '#skills-section',
          start: 'top 70%',
          toggleActions: 'play none none reverse',
        },
      }
    );

    animateAboutMeSectionLeave('#skills-section');
  });
</script>
